import axios, { AxiosError } from "axios";
import { getAuth } from "firebase/auth";

axios.interceptors.response.use(undefined, function (error: AxiosError) {
	const { response, config } = error;
	const newResponse: any = {};
	const newConfig: any = {
		url: config.url,
		method: config.method,
		headers: config.headers,
	};

	if (config.url != null) {
		newConfig.data = config.data;
	}

	if (response != null) {
		if (response.status === 404) {
			return Promise.reject(error);
		}

		if (response.status === 401) {
			getAuth()
				.signOut()
				.then(() => {
					window.location.href = "/login";
				});
		}

		newResponse.status = response.status;
		newResponse.statusText = response.statusText;
		newResponse.headers = response.headers;

		if (response.data != null && response.data.message) {
			newResponse.dataMessage = response.data.message;
		}
	}

	return Promise.reject(error);
});

const hostname = window && window.location && window.location.hostname;
let serverPath = "";
// serverPath = "https://www.choze.app/api";
if (hostname === "localhost") {
	serverPath = "http://localhost:3000";
} else {
	serverPath = "https://www.choze.app/api";
}

export class ApiService {
	public async defaults() {
		const token = await getAuth().currentUser?.getIdToken();
		return {
			headers: {
				"Request-Source": "creaciones",
				"Content-Type": "multipart/form-data",
				authorization: `Bearer ${token}`,
			},
		};
	}

	public async defaultsJSON() {
		const token = await getAuth().currentUser?.getIdToken();
		return {
			headers: {
				"Request-Source": "creaciones",
				"Content-Type": "application/json",
				authorization: `Bearer ${token}`,
			},
		};
	}

	// public async loginUser(form: FormData) {
	// 	return axios
	// 		.post(`${serverPath}/Users/login`, form, await this.defaults())
	// 		.then((res) => {
	// 			return res;
	// 		})
	// 		.catch((error) => {
	// 			return error.response;
	// 		});
	// }

	public async TiposClientesListado() {
		return axios
			.get(`${serverPath}/TiposClientes/Listado`, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ClientesSave(form: FormData) {
		return axios
			.post(`${serverPath}/Clientes/save`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ClientesListado(form: FormData) {
		return axios
			.post(`${serverPath}/Clientes/clientesListado`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ClientesEliminar(form: FormData) {
		return axios
			.post(`${serverPath}/Clientes/clientesEliminar`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async CategoriasSave(form: FormData) {
		return axios
			.post(`${serverPath}/Categorias/save`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async CategoriasListado(form: FormData) {
		return axios
			.post(`${serverPath}/Categorias/categoriasListado`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async CategoriaPorId(form: FormData) {
		return axios
			.post(`${serverPath}/Categorias/categoriasPorId`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async CategoriasEliminar(form: FormData) {
		return axios
			.post(`${serverPath}/Categorias/categoriasEliminar`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ProductosSave(form: FormData) {
		return axios
			.post(`${serverPath}/Productos/save`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ProductosListado(form: FormData) {
		return axios
			.post(`${serverPath}/Productos/productosListado`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ProductoPorId(form: FormData) {
		return axios
			.post(`${serverPath}/Productos/productosPorId`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ProductosEliminar(form: FormData) {
		return axios
			.post(`${serverPath}/Productos/productosEliminar`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PresentacionesSave(form: FormData) {
		return axios
			.post(`${serverPath}/Presentaciones/save`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PresentacionesListado(form: FormData) {
		return axios
			.post(`${serverPath}/Presentaciones/presentacionesListado`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PresentacionesPorId(form: FormData) {
		return axios
			.post(`${serverPath}/Presentaciones/presentacionesPorId`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PresentacionesEliminar(form: FormData) {
		return axios
			.post(`${serverPath}/Presentaciones/presentacionesEliminar`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PedidosSave(form: FormData) {
		return axios
			.post(`${serverPath}/Pedidos/save`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PedidosListado(form: unknown) {
		return axios
			.post(`${serverPath}/Pedidos/pedidosListado`, form, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PedidosPorId(form: FormData) {
		return axios
			.post(`${serverPath}/Pedidos/pedidosPorId`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async PedidosEliminar(form: FormData) {
		return axios
			.post(`${serverPath}/Pedidos/pedidoEliminar`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async pedidoDetalle(form: FormData) {
		return axios
			.post(`${serverPath}/Pedidos/pedidoDetalle`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async pedidosRegistros(form: unknown) {
		return axios
			.post(`${serverPath}/Pedidos/pedidosRegistro`, form, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async pedidosCotizaciones(form: unknown) {
		return axios
			.post(`${serverPath}/Pedidos/pedidosCotizaciones`, form, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async guardaCaptura(form: FormData) {
		return axios
			.post(`${serverPath}/Pedidos/guardarCaptura`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async guardarCuenta(form: FormData) {
		return axios
			.post(`${serverPath}/Cuentas/save`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async listadoCuentas(form: FormData) {
		return axios
			.post(`${serverPath}/Cuentas/cuentaListado`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async borrarCuentas(form: FormData) {
		return axios
			.post(`${serverPath}/Cuentas/cuentasEliminar`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async listaTiposPagos() {
		return axios
			.get(`${serverPath}/Pagos/listaTiposPagos`, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async guardarPagos(form: unknown) {
		return axios
			.post(`${serverPath}/Pagos/save`, form, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async borrarPagos(form: FormData) {
		return axios
			.post(`${serverPath}/Pagos/delete`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async listarPagos(form: FormData) {
		return axios
			.post(`${serverPath}/Pagos/listado`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async listarPagosPedido(form: FormData) {
		return axios
			.post(`${serverPath}/Pagos/pagosTotales`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async guardarRol(form: unknown) {
		return axios
			.post(`${serverPath}/Roles/save`, form, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async listadoRoles(obj: unknown) {
		return axios
			.post(`${serverPath}/Roles/RolListado`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async borrarRol(form: FormData) {
		return axios
			.post(`${serverPath}/Roles/RolesEliminar`, form, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async RolesOpciones() {
		return axios
			.get(`${serverPath}/Roles/RolesOpciones`, await this.defaults())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async RolOpcionesAct(obj: unknown) {
		return axios
			.post(`${serverPath}/Roles/RolOpcionesAct`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async crearUsuario(obj: unknown) {
		return axios
			.post(`${serverPath}/Users/regist`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async ActualizarUsuario(obj: unknown) {
		return axios
			.post(`${serverPath}/Users/upd`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async elimUsuario(obj: unknown) {
		return axios
			.post(`${serverPath}/Users/elim`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async listadoUsuario(obj: unknown) {
		return axios
			.post(`${serverPath}/Users/listado`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async permisosListado(obj: unknown) {
		return axios
			.post(`${serverPath}/Users/permisosListado`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}

	public async getPermisos(obj: unknown) {
		return axios
			.post(`${serverPath}/Users/getPermisos`, obj, await this.defaultsJSON())
			.then((res) => {
				return res;
			})
			.catch((error) => {
				return error.response;
			});
	}
}
export default new ApiService();
